import { getScript } from 'js/utils/scripts.util';
import { useCallback } from 'react';

import * as Types from '../../../types';

export const useXpointDownloadSDK = ({
    sdkUrl
}: {
    sdkUrl: string;
}) => {
    return useCallback(async () => {
        if (!window.xpoint) {
            await getScript(sdkUrl);
        }

        return window.xpoint!.WebSdk.getInstance() as Types.GeofencingSdkInstance;
    }, [sdkUrl]);
};
